
jQuery(document).ready(function($) {

    const usersInput = $('form input.multi-users');
    if (usersInput.length) {
        usersInput.tagsInput({
            placeholder:'Benutzer hinzufügen',
            minChars: 2,
            maxChars: 10,
            limit: 10,
            unique: true,
            autocomplete:{
                autoFocus:true,
                source: usersInput.data('source'),
                select: function(e, ui){
                    console.log(ui);
                },
            },
            onAddTag: function(){
                console.log('onAdd', arguments);
            }
        });
    }

});
